export function setDebitCreditValue(entry, configs, propertyName) {
    // عند تحديد العملة => وضع سعر العملة
    // وضع سعر العملة  => تحديث المدين والدائن 
    // عند تغيير العملة المدينة أو الدائنة => تحديث المدين والدائن 
    // تحديث المدين = السعر * العملة المدينة والعكس بالعكس من أجل الدائنة
    //  عند تعديل المدين أو الدائن ويوجد قيم (عملة مدينة/دائنة - العملة - السعر) => حذف مُحتوى العملة المدينة أو الدائنة
    // 
    // عند تحديث عملة مدينة أودائنة إما يحُدث المدين فقط أو الدائن فقط وفي حال وجود كلاهما يحدث المدين فقط 
    // مراعاة إدخال السعر بدون عملات دائنة ومدينة  
    // مراعاة إدخال عملات دائنة و مدينة بدون سعر
    // لا يجوز بأي حال من الأحوال حذف السعر لأنهُ مُدخل من قبل المُستخدم  وهو قيمة غير مُرتجعة
    if(!!entry.currency_id && !entry.currency_price)
    {
        entry.currency_price = configs.currencies.find(c=>c.id == entry.currency_id)?.latest_exchange_record
    }
    if(entry.currency_debit?.amount && !!entry.currency_id && entry.currency_price)
    {
        if(!entry.debit && propertyName != "debit")
            entry.debit = {amount: entry.currency_debit.amount * entry.currency_price , currency_id: configs.financial_file.default_currency_id}
        else
        {
            if(entry.debit?.amount !=  entry.currency_debit.amount * entry.currency_price && propertyName == "debit") // debit changed
                entry.currency_debit = null
            else if(entry.debit?.amount !=  entry.currency_debit.amount * entry.currency_price && propertyName == "currency_debit") // currency_debit changed
                entry.currency_price = entry.debit.amount / entry.currency_debit.amount
            else if(entry.debit?.amount !=  entry.currency_debit.amount * entry.currency_price && propertyName == "currency_price") // currency_price changed
                entry.debit = {amount: entry.currency_debit.amount * entry.currency_price , currency_id: configs.financial_file.default_currency_id}
            }
    }
    if(entry.currency_credit?.amount && !!entry.currency_id && entry.currency_price)
    {
        if(!entry.debit?.amount)
        {
            if(!entry.credit?.amount && propertyName != "credit")
                entry.credit = {amount: entry.currency_credit.amount * entry.currency_price , currency_id: configs.financial_file.default_currency_id}
            else
            {
                if(entry.credit?.amount !=  entry.currency_credit.amount * entry.currency_price && propertyName == "credit") // credit changed
                    entry.currency_credit = null
                else if(entry.credit?.amount !=  entry.currency_credit.amount * entry.currency_price && propertyName == "currency_credit") // currency_credit changed
                    entry.currency_price = entry.credit.amount / entry.currency_credit.amount 
                else if(entry.credit?.amount !=  entry.currency_credit.amount * entry.currency_price && propertyName == "currency_price") // currency_price changed
                    entry.credit = {amount: entry.currency_credit.amount * entry.currency_price , currency_id: configs.financial_file.default_currency_id}
            }
        }
    }
}
import { transactionType } from '@/helpers/enums'
import _ from 'lodash'
export function refactorEntry(entry, default_currency_id){
    var entry_template = {
        id: null,
        account_id: null,
        bond_id: null,
        created_at: null,
        credit: null,
        currency_credit: null,
        currency_debit: null,
        currency_price: null,
        date: null,
        debit: null,
        deleted_at: null,
        is_cash: null,
        linked_entry_id: null,
        note: null,
        order_inside_bond: null,
        paper_document_no: null,
    }
    //lodash library
    //_.set(object, path, value)
    Object.entries(entry).forEach(([key, value]) => _.set(entry_template, key, value))
    entry_template.currency_credit = entry.currency_credit?.amount ? _.set(entry.currency_credit,"currency_id", entry.currency_id) : null
    entry_template.currency_debit = entry.currency_debit?.amount ? _.set(entry.currency_debit,"currency_id", entry.currency_id): null
    entry_template.credit = entry.credit?.amount ?  _.set(entry.credit,"currency_id", default_currency_id) : null
    entry_template.debit = entry.debit?.amount ? _.set(entry.debit,"currency_id", default_currency_id) : null
    return entry_template
}

export function refactorMaterialEntry(material_entry, default_currency_id, unit_size_id, skipValue = {}){
    var material_entry_template = {
        id: null,
        invoice_id: null,
        material_id: null,
        in_quantity: null,
        out_quantity: null,
        count: null,
        price: null,
        notes: null,
        type: null,
        account_id: null,
        doc_no: null,
        no: 0
    }
    Object.entries(material_entry).forEach(([key, value]) => _.set(material_entry_template, key, value))
    if(material_entry.out_quantity)
    {
        material_entry_template.quantity =  { quantity: material_entry.out_quantity, unit_size_id }
        material_entry_template.type = transactionType.out
    }

    if(material_entry.in_quantity)
    {
        material_entry_template.quantity =  { quantity: material_entry.in_quantity, unit_size_id }
        material_entry_template.type = transactionType.in
    }
    
    material_entry_template.price =
        !skipValue.price
            ? material_entry.price && material_entry.price.amount
                ? { amount: material_entry.price.amount, currency_id: default_currency_id }
                : null
            : { amount: 0, currency_id: default_currency_id }
    return material_entry_template
}